import React, { useContext, useState, useEffect } from "react";
import { DownOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import { context } from "../context/Context";
import { color } from "../../styles/color";
import { useParams, useHistory } from "react-router-dom";
import { Obj } from "../../client_types";
import { MenuProps, Dropdown } from "antdv5";
import useAuthAndPath from "components/customHook/useAuthAndPath";

const Box = styled.div`
  order: 1;
  width: 100%;
  @media (min-width: 768px) {
    order: 2;
    width: auto;
    max-width: 120px;
  }
  @media print {
    display: none;
  }
  .ant-dropdown-trigger {
    border: 1px solid ${color.markedSecondary};
    border-radius: 0.2rem;
    padding: 0.2rem 0.5rem;
    color: ${color.markedSecondary};
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

interface IProps {
  clubList: any[] | null;
}
const ClubOpts = ({ clubList }: IProps) => {
  const { dispatch, state } = useContext(context);
  const history = useHistory();
  const noAuthPath = ["scan_detail", "daily_record"];
  const handleClick = (data: Obj) => {
    if (noAuthPath.includes(history.location.pathname.split("/")[1])) {
      history.push(`${data.Clubid}`);
    } else {
      return;
    }
  };
  const nowClub = `${state.clubID || ""} - ${state.clubName || ""}`;

  useAuthAndPath((onAuth, role, clubID) => {}, []);
  // replace
  // useEffect(() => {
  //   const onAuth = localStorage.getItem("onAuth") === "true";
  //   const hasClubList = clubList && clubList.length > 0;
  //   if (!onAuth && hasClubList) {
  //     const urlToClubOpt = clubList?.find((data) => data.Clubid === clubID);
  //     if (urlToClubOpt) {
  //       const urlToString = `${urlToClubOpt.Clubid} - ${urlToClubOpt.ClubName}`;
  //       // dispatch({ clubID });
  //       localStorage.setItem("clubName", urlToClubOpt.ClubName);
  //       localStorage.setItem("gid", urlToClubOpt.Gid);
  //       setNowClub(urlToString);
  //     } else {
  //       alert("查无鸽会");
  //       history.push("001");
  //     }
  //   } else if (
  //     onAuth &&
  //     hasClubList &&
  //     noAuthPath.includes(history.location.pathname.split("/")[1])
  //   ) {
  //     const urlToClubOpt = clubList?.find((data) => data.Clubid === clubID);
  //     if (urlToClubOpt) {
  //       const urlToString = `${urlToClubOpt.Clubid} - ${urlToClubOpt.ClubName}`;
  //       // dispatch({ clubID });
  //       // localStorage.setItem("clubID", clubID);
  //       localStorage.setItem("clubName", urlToClubOpt.ClubName);
  //       localStorage.setItem("gid", urlToClubOpt.Gid);
  //       setNowClub(urlToString);
  //     } else {
  //       alert("查无鸽会 已登入");
  //       history.push("001");
  //     }
  //   } else {
  //     return;
  //   }
  // }, [clubList, clubID]);
  const items: MenuProps["items"] =
    (clubList &&
      clubList.map((data, i) => ({
        key: i,
        label: `${data.Clubid} - ${data.ClubName}`,
        onClick: () => {
          dispatch({
            gid: data.Gid,
            clubName: data.ClubName,
            clubID: data.Clubid,
          });
          handleClick(data);
        },
      }))) ||
    [];
  return (
    <Box>
      <Dropdown menu={{ items }} trigger={["click"]}>
        <div
          className="ant-dropdown-link"
          onClick={(e) => {
            e.preventDefault();
          }}
        >
          {/* {localStorage.getItem('clubID') ? 
            localStorage.getItem('clubID') - localStorage.getItem('clubName')
            :
            (localStorage.setItem('clubID', '001'), localStorage.setItem('clubName', 'System'))
            `001 - System`
          } */}
          {nowClub} <DownOutlined />
        </div>
      </Dropdown>
    </Box>
  );
};
export default ClubOpts;
